export default __webpack_public_path__ + "static/media/controls.80741480.md";